// Generated by CoffeeScript 1.12.7

/*
employeeRoles wrapped as an angular service
 */
angular.module(__filename, []).factory('employeeRoles', [
  '$rootScope', '$location', function($rootScope, $location) {
    var employeeRoles;
    return employeeRoles = require('..');
  }
]);

module.exports = __filename;
